import InfoColumn from './InfoColumn';

export default InfoColumn;
